var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundimage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 812,
    viewBox: "0 0 375 812",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_938_7775)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    fill: "#F6F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H375V812H0V0Z",
    fill: "#F6F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375 0H0V400C0.269699 296.677 84.1133 213 187.5 213C290.887 213 374.73 296.677 374.999 400L375 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0957 929.096C58.449 929.094 96.1834 904.85 116.076 869.003L211.716 927.2C171.981 993.534 99.152 1038 15.8484 1038C-109.982 1038 -211.996 936.602 -212 811.509C-212.006 686.415 -109.997 585.006 15.8337 585C83.2883 584.998 143.876 614.157 185.593 660.462L103.949 735.404C82.6748 709.605 50.7807 693.176 15.0873 693.176C-48.9538 693.178 -100.865 745.991 -100.863 811.14C-100.861 876.287 -48.9454 929.098 15.0957 929.096ZM123.171 763.036L184.431 756.989C187.882 756.649 190.931 759.174 191.136 762.64C192.042 778.107 190.533 818.256 151.845 832.352C147.531 833.923 140.867 835.487 130.508 836.875C129.374 837.024 128.374 836.037 128.602 834.917C130.164 827.23 131.05 819.292 131.05 811.132C131.048 794.841 127.738 779.36 121.859 765.249C121.44 764.243 122.087 763.144 123.171 763.036ZM43.6644 772.03C43.6644 763.962 50.095 757.42 58.0269 757.42C65.9567 757.42 72.3874 763.962 72.3874 772.028C72.3874 780.097 65.9567 786.639 58.0269 786.639C50.095 786.639 43.6644 780.097 43.6644 772.03Z",
    fill: "#F04E30",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M728.753 789.893C819.958 789.889 899.342 738.885 941.192 663.473L1142.39 785.903C1058.8 925.455 905.587 1019 730.337 1019C465.621 1019.01 251.009 805.683 251 542.52C250.987 279.353 465.59 66.0133 730.306 66C872.214 65.9956 999.675 127.34 1087.44 224.754L915.678 382.412C870.923 328.138 803.826 293.576 728.736 293.576C594.009 293.58 484.8 404.686 484.805 541.743C484.809 678.797 594.027 789.897 728.753 789.893ZM956.116 440.545L1084.99 427.821C1092.25 427.107 1098.67 432.419 1099.1 439.71C1101.01 472.249 1097.83 556.714 1016.44 586.367C1007.37 589.673 993.344 592.962 971.552 595.882C969.166 596.197 967.063 594.12 967.542 591.763C970.829 575.592 972.692 558.892 972.692 541.727C972.688 507.454 965.724 474.884 953.357 445.2C952.475 443.083 953.836 440.771 956.116 440.545ZM788.855 459.466C788.855 442.491 802.383 428.729 819.07 428.729C835.752 428.729 849.281 442.491 849.281 459.461C849.281 476.436 835.752 490.198 819.07 490.198C802.383 490.198 788.855 476.436 788.855 459.466Z",
    fill: "#F04E30",
    fillOpacity: 0.03
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_938_7775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundimage);
export default __webpack_public_path__ + "static/media/Background image.7978e427354f0f98f4667fee5cfbddd8.svg";
export { ForwardRef as ReactComponent };